export const get = (name) => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
};

export const set = (name, value, options = {}) => {
  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)};path=/`;
  if (options.secure) cookie += ';secure';
  if (options.sameSite) cookie += `;samesite=${options.sameSite}`;
  if (options.expires) cookie += `;expires=${options.expires.toUTCString()}`;
  if (options.maxAge) cookie += `;max-age=${options.maxAge}`;
  document.cookie = cookie;
};

export const remove = (name) => {
  document.cookie = `${encodeURIComponent(name)}=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
};

export default { get, set, remove };
